import "../sellscreendialogs.scss";
import { type FC, useState } from "react";
import { TouchNumbers } from "@onshopfront/components";
import { type ShopfrontDispatch, useShopfrontDispatch } from "#/_Bootstrap/hooks.ts";
import { hideDialog } from "#/Actions/Dialogs/DialogActions.ts";
import { addProductToSale, type SaleAddProductOptions } from "#/Actions/SellScreen/SellScreenProductActions.tsx";
import { type ProductTypeUnion } from "#/Data/_Bases/BaseProductRepository.ts";
import Button from "../../../../Common/Buttons/Button";
import PopupManager from "../../../../Common/Popups/PopupManager";

interface Props {
    uuid: string;
    name: string;
    type: ProductTypeUnion;
    options: SaleAddProductOptions;
    dispatch?: ShopfrontDispatch;
}

export const RequestPrice: FC<Props> = ({ uuid, name, type, options, dispatch: overrideDispatch }) => {
    const negative = (options.quantity as number) < 0;

    let dispatch = useShopfrontDispatch();

    if(overrideDispatch) {
        dispatch = overrideDispatch;
    }

    const [ value, setValue ] = useState<null | number>(null);

    const addProduct = () => {
        if(value === null || isNaN(value)) {
            PopupManager.warning("Please enter valid price");

            return;
        }

        if(type === "voucher" && value === 0) {
            PopupManager.warning("Vouchers cannot have a price of $0, please enter a different price");

            return;
        }

        dispatch(hideDialog());
        dispatch(addProductToSale(uuid, {
            ...options,
            price : value,
            edited: true,
        }));
    };

    return (
        <div className="request-price max-w-lg">
            <p>Please enter the price for {name}:</p>
            <div className="mx-auto w-fit">
                <TouchNumbers
                    onKeyDown={(e) => {
                        if(e.key === "Enter") {
                            addProduct();

                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                    min={negative ? undefined : 0}
                    max={negative ? 0 : undefined}
                    negative={negative}
                    value={value}
                    onChange={setValue}
                    input="currency"
                    data-testid="request-price-touch-number"
                    autoFocus
                />
            </div>
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    data-testid="request-price-cancel"
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-primary" ]}
                    data-testid="request-price-add"
                    onClick={addProduct}
                >
                    Add
                </Button>
            </div>
        </div>
    );
};
